export type PublishDateOrCreatedAt = {
  fields: {
    publishDateOverride?: string;
  };
  sys: {
    createdAt: string;
  };
};

/** Date format of the articles publication date, using the "publishDateOverride" entry property if present and otherwise
 * defaulting to the Entry creation date. */
const PublicationDateString = <T extends PublishDateOrCreatedAt>({
  articleEntry,
}: {
  articleEntry: T;
}) => {
  const publicationDate = articleEntry.fields.publishDateOverride ?? articleEntry.sys.createdAt;
  const publicationDateString = new Date(publicationDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return <span>{publicationDateString}</span>;
};

export default PublicationDateString;
